import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Image from '../../atoms/Image/Image'; 

const InnerBanner = ({ title, subtitle, imageSrc, imageAlt = '', imageWidth = "1920", imageHeight = "450" }) => {
  return (
    <section className="inner-banner">
      <figure className="mb-0 inner-banner--image">
        <Image src={imageSrc} alt={imageAlt} width={imageWidth} height={imageHeight} />
      </figure>
      <div className="inner-banner--content">
        <Container>
          <Row>
            <Col>
              <h1 className="h1">{title}</h1>
              {subtitle && <p className="mb-0">{subtitle}</p>}
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default InnerBanner;
